import styled from "@emotion/styled";

import { MDSIcon, MDSIconKind, MDSTextVariant } from "@/mds";

export const AgentBackLink = ({ label, onClick }: { label: string; onClick: () => void }) => (
  <StyledButton type="button" onClick={onClick}>
    <MDSIcon kind={MDSIconKind.AngleLeft} size={14} />
    <span>{label}</span>
  </StyledButton>
);

const StyledButton = styled.button`
  align-items: center;
  align-self: flex-start;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-size: ${({ theme }) => theme.fontSizes[MDSTextVariant.TextS]};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  gap: ${({ theme }) => theme.spacing[1]};
  padding: 0;

  &:hover {
    color: ${({ theme }) => theme.colors.text.secondary};
  }
`;
